import * as React from "react";
import FlagSharpIcon from "@material-ui/icons/FlagSharp";
import { Release } from "../../../../../../../../common/types/release/release";
import SimpleArtist from "../../../../../../../../common/types/artist/simple-artist";
import styled from "styled-components";
import { getReleaseOwnerArtist } from "../../../../../utils/get-owner-artist";
import Chip from "@material-ui/core/Chip";
import Link from "@material-ui/core/Link";
import { routes } from "../../../../../routes";
import { Subscription } from "../../../../../../../../services/subscription/types/subscription";
import { ToolTip } from "../../../../../components/tooltip";
interface ReleaseDetailHeaderProps {
  release: Release;
  subscription?: Subscription;
  artists: SimpleArtist[];
}

export const ReleaseDetailHeader: React.FC<ReleaseDetailHeaderProps> = (
  props
) => {
  const { release, subscription, artists } = props;
  const enabled: boolean = !release.artists.some(
    (val) => val.enabled === false
  );
  const watchlistNote: string | undefined = artists.find(
    (artist) => artist.watchlistNote
  )?.watchlistNote;

  let plan = subscription?.plan || "Beginner";
  if (!subscription?.isActive) {
    plan = `${plan} (INACTIVE)`;
  }

  return (
    <HeaderContainer>
      <EmptyDiv>
        <CoverArt src={release.cover.url} />
        <HeaderInformation>
          <AlbumTitle>{release.title}</AlbumTitle>
          <AlbumArtist>
            <Link
              color="inherit"
              href={`${routes.artist.list}/${
                getReleaseOwnerArtist(release)?.id
              }`}
            >
              {getReleaseOwnerArtist(release)?.name || ""}
            </Link>{" "}
            / {release.recordLabel}
          </AlbumArtist>
          {plan ? (
            <Chip
              size="small"
              label={plan}
              color={plan.includes("Pro") ? "primary" : "default"}
            />
          ) : (
            <></>
          )}
          <IdContainer>UPC: {release.UPCEAN}</IdContainer>
          <IdContainer>Internal: {release.id}</IdContainer>
          <IdContainer>Status: {release.status}</IdContainer>
          <IdContainer>
            Last action taken: {release.backofficeStatus}
          </IdContainer>
        </HeaderInformation>
      </EmptyDiv>
      {watchlistNote && (
        <ToolTip helperText={watchlistNote}>
          <FlagSharpIcon color="error" fontSize="large" />
        </ToolTip>
      )}
      {!enabled && <Chip size="small" label={"Blocked"} color="secondary" />}
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
`;

const CoverArt = styled.img`
  width: 180px;
  height: 180px;
  margin-right: 1rem;
  border-radius: 4px;
`;

const HeaderInformation = styled.div``;

const EmptyDiv = styled.div`
  display: flex;
`;

const AlbumTitle = styled.h2`
  margin: 0 0 5px;
`;

const AlbumArtist = styled.h3`
  margin: 0 0 20px;
`;

const IdContainer = styled.p`
  margin: 0 0 5px;
`;
